import initVueApp from "@/core.js";
const component = require(`./../views/SustainabilityReport2025.vue`).default;

import VueGoogleMaps from "vue-google-maps-community-fork";

const plugins = [
  {
    plugin: VueGoogleMaps,
    options: {
      load: {
        key: "AIzaSyDiqVvaUnAvdiRW_8yQdg-r286Ir7kYdHo",
      },
    },
  },
];

initVueApp(component, null, plugins);
